<template>
  <vs-row>
    <vs-col :vs-w="showFiltersTransition ? 9 : 12" class="p-2">
      <vx-card v-if="members"
               v-show="filterValues">
        <div class="flex flex-end">
          <feather-icon class="filter-hover-button" @click="onShowFilters()" icon="FilterIcon" svgClasses="h-8 w-8 mb-1 mr-3 stroke-current text-primary"/>
        </div>
        <sm-hateoas-table
          ref="membersTable"
          @selected="handleSelected"
          :paged-resources="members"
          :relation="'members'"
          :search="true"
          :pagination="true"
          :filters="filterValues">
          <template slot="thead">
          <vs-th sort-key="createdDate">
            {{ $t('view_members.member_since') }}
          </vs-th>
          <vs-th sort-key="firstName">
            {{ $t('view_members.name') }}
          </vs-th>
          <vs-th width="20%">
            {{ $t('view_members.program') }}
          </vs-th>
          <vs-th v-if="isCaseManagerTeamOn">
            {{ hqTeamLabel }}
          </vs-th>
          <vs-th>
            {{ $t('view_members.last_activity') }}
          </vs-th>
          <vs-th>
          </vs-th>
          </template>

          <template slot-scope="{data}">
          <vs-tr :data="tr" :key="data[indextr].id" v-for="(tr, indextr) in data">

            <vs-td :data="data[indextr].memberSince">
              {{ data[indextr].memberSince | moment('MMM D, YYYY') }}
            </vs-td>

            <vs-td :data="data[indextr].firstName">
              <div>
            <span>{{data[indextr].firstName}} {{data[indextr].lastName}}</span>
              </div>
              <div>
                <span>{{data[indextr].email}}</span>
              </div>
              <div>
                <span>{{ userIdLabel}}: {{data[indextr].claimNumber}}</span>
              </div>
            </vs-td>

            <vs-td :data="data[indextr].program">
              <span v-if="data[indextr].$hasEmbedded('access-code')">{{ $t('filters.REFERRAL_PROGRAMS.values.' + data[indextr].$getEmbedded('access-code').program) }}</span>
              <span v-else>{{ $t('filters.REFERRAL_PROGRAMS.values.none')}}</span>
            </vs-td>

             <vs-td v-if="isCaseManagerTeamOn" :data="data[indextr].hqTeamName">
               {{data[indextr].hqTeamName ? data[indextr].hqTeamName : '--'}}
             </vs-td>


            <vs-td v-if="data[indextr].lastActivity" :data="data[indextr].lastActivity">
              {{data[indextr].lastActivity | moment('MMM D, YYYY')}}
            </vs-td>
            <vs-td v-else>
              --
            </vs-td>

            <vs-td>
              <vs-row>
                <vs-col vs-w="9" class="p-2">
                  <vs-row>
                    <vs-col class="p-2">
                      <vs-button
                        v-if="data[indextr].$hasLink('member')"
                        @click="onView(data[indextr])"
                        type="filled"
                        color="success"
                        class="w-full">{{ $t('view_members.buttons.view_member') }}
                      </vs-button>
                    </vs-col>
                  </vs-row>
                </vs-col>
              </vs-row>
            </vs-td>

          </vs-tr>
          </template>
        </sm-hateoas-table>
      </vx-card>
    </vs-col>
     <vs-col :vs-w="3" class="p-2">
      <sm-hateoas-filters ref="onFilter" v-if="filters" v-show="showFiltersTransition" :filter-resource="filterResource" @update-transition="onUpdateFilterTransition" :filters="filters" @filters-change="onFilterChange"></sm-hateoas-filters>
    </vs-col>
  </vs-row>
</template>

<script>
import SmHateoasTable from '@/components/starling/sm-hateoas-table/sm-hateoas-table';
import {ResourceImpl} from 'hal-client';
import SmHateoasFilters from '@/components/starling/sm-hateoas-filters/sm-hateoas-filters';
import moment from 'moment';

export default {
  name: 'view-members',
  now: new Date(),
  components: {
    SmHateoasFilters,
    SmHateoasTable
  },
  props: {
    membersResource: {
      type: ResourceImpl,
      required: true
    }
  },
  data () {
    return {
      members: this.membersResource,
      filters: null,
      filterValues: null,
      showFiltersTransition: false,
      refreshKey: 0,
      intervalId: null,
      userIdLabel : null,
      filterResource: null,
      isCaseManagerTeamOn: null,
      hqTeamLabel: null
    };
  },
  mounted () {
    this.members.$request().$get('user-id-label', null, {locale:'en'}).then((res) => {
      this.userIdLabel = res.state().label;
      if (!this.userIdLabel) {
        this.userIdLabel = this.$t('view_member.block.report.fields.user_id');
      }
    });
    this.members.$request().$get('hq-team-label', null, {locale:'en'}).then((res) => {
      this.isCaseManagerTeamOn = res.state().enabled;
      this.hqTeamLabel = res.state().label;
      if (!this.hqTeamLabel) {
        this.hqTeamLabel = this.$t('view_members.team');
      }
    });
    if (this.members.$hasLink('filters')) {
      this.members.$request().$get('filters').then(res => {
        this.filters = res.$getEmbedded('filters');
        this.filterResource = res;
      });
    }
  },
  methods: {
    handleSelected () {
    },
    onCheckTime (lastSent) {
      return !moment().isAfter(moment(lastSent).add(5, 'm'));
    },
    onFilterChange (filters) {
      this.filterValues = filters;
    },
    refreshTable () {
      this.$refs.membersTable.refresh();
    },
    onUpdateFilterTransition () {
      this.showFiltersTransition = !this.showFiltersTransition;
    },
    onShowFilters () {
      this.$refs.onFilter.onShowFilters();
    },
    onView (member) {
      this.$router.push({
        name: 'app-view-member',
        params: {id: member.id}
      });
    }
  }
};
</script>

<style scoped>

</style>
